export default __webpack_public_path__ + "static/media/intro.10747870.jpg";